import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
export default Vue.extend({
    computed: { ...mapGetters('productModule', ['currentProductRate']) },
    methods: {
        changeRate(rate) {
            this.setRate(rate);
        },
        ...mapMutations('productModule', ['setRate']),
    },
});
